import { Link } from '@ta-interaktiv/contentbricks'
import React from 'react'

export const TEXT_FR = {

    title: "Comparez votre consommation d'alcool",
    lead:
        "Combien de bière, de vin et d'alcool fort buvez-vous en comparaison avec les autres lecteurs et lectrices? Et à partir de quand votre consommation devient-elle risquée? Notre calculateur d'alcool le sait.",
    date: 'Mis à jour le 23 juin 2022',
    intro:
        'Notre outil interactif vous montre combien vous buvez par rapport aux autres lecteurs et comment vous vous situez par rapport à la moyenne suisse.',
    agegroups: {
        age_15_24: '15-24 ans',
        age_25_34: '25-34 ans',
        age_35_44: '35-44 ans',
        age_45_54: '45-54 ans ',
        age_55_64: '55-64 ans',
        age_65_74: '65-74 ans',
        age_75: 'Plus de 75 ans'
    },
    calculator: {
        earlyfeedback: (
            <>
                Avez-vous des remarques?{" "}
                <a href='mailto:interactif@tamedia.ch?subject=calculateur%20d%20alcool'>
                    interactif@tamedia.ch
                </a>
            </>
        ),
        select: 'Veuillez sélectionner',
        title: "Combien de verres standards d'alcool buvez-vous par semaine?",
        lead: (
            <>
                Un <b>verre standard d'alcool</b> contient entre 10 et 12 grammes
                d'alcool pur. C'est à peu près la quantité contenue dans une bière (3
                décilitres), un verre de vin (1 décilitre) ou un petit verre d'alcool
                fort (0,3 décilitre).
            </>
        ),

        drinks: ['Verre de bière', 'Verre de vin', 'Alcool fort'],
        questions: [
            ['Votre genre?', 'Femme', 'Homme'],
            [
                'Combien de fois buvez-vous par semaine?',
                'Jamais',
                "Moins d'une fois par semaine",
                'Une à deux fois par semaine',
                'Trois à six fois par semaine',
                'Quotidiennement'
            ],
            [
                'Buvez-vous au moins une fois par mois plus de 5 verres standards (hommes) ou 4 verres standards (femmes) en un jour?',
                'Oui',
                'Non'
            ],
            [
                "Votre tranche d'âge?",
                '15–24 ans',
                '25–34 ans',
                '35–44 ans',
                '45–54 ans',
                '55–64 ans',
                '65–74 ans',
                'Plus de 75 ans'
            ]
        ],
        disclaimer:
            'Toutes les données sont utilisées exclusivement pour la visualisation. Elles ne sont pas transmises, sont anonymes et ne sont pas associées à des données personnelles.',
        buttons: ['Évaluer', 'Merci pour votre participation!'],
        fillout: "Complétez vos données pour accéder à l'évaluation!"
    },
    risk: {
        otherCats: 'Les autres niveaux de risque sont:',
        diclaimer: (
            <>
                {' '}
                Toutes les recommandations et classifications utilisées en matière de
                consommation d'alcool proviennent de
                <Link href='https://www.bag.admin.ch/bag/fr/home/gesund-leben/sucht-und-gesundheit/alkohol/problemkonsum.html'>
                    l'Office fédéral de la santé publique
                </Link>{' '}
                et sont établies dans la recherche internationale sur l'alcool.
            </>
        ),
        getHelp: (
            <>
                Si vous avez l'impression d'avoir un problème d'alcool,{' '}
                <Link
                    href='https://www.addictionsuisse.ch/aide-et-conseil/'
                    allowWordWrap={false}
                >
                    vous trouverez de l'aide ici.
                </Link>
            </>
        ),
        gender: {
            m: ['Participant ', 'Participants'],
            f: ['Participantes', 'Participantes']
        },
        user: {
            none: "Vous êtes abstinent ou buvez très rarement de l'alcool.",

            low: 'Votre consommation est à faible risque',

            middle: 'Votre consommation est probablement risquée.',

            high: (
                <>
                    Votre consommation est <b>chroniquement à risque</b> ou bien vous êtes
                    un <b>Buveur excessif (ivresse ponctuelle)</b>.
                </>
            )
        },
        frequency: {
            none: "vivre dans l'abstinence",
            low: 'boire à faible risque',
            middle: 'boire potentiellement à risque',
            high: ' boire à risque'
        },
        groups: {
            none: (
                <>
                    <h5>Abstinent</h5> Ce niveau comprend toutes les personnes qui ne
                    boivent pas d'alcool.
                </>
            ),

            low: (
                <>
                    <h5>À faible risque</h5>
                    <ul>
                        <li>
                            Lorsqu'une <b>femme</b> ne consomme pas plus d'un verre standard
                            d'alcool (10 à 12 grammes) par jour, c'est peu dommageable. Si,
                            exceptionnellement, cela devient plus, pas plus de 4 verres. Il
                            convient de renoncer à l'alcool au moins deux jours par semaine.
                        </li>
                        <li>
                            Pour les <b>hommes</b>, la limite se situe entre 20 et 24 grammes,
                            ce qui correspond à deux verres standards d'alcool par jour. Si la
                            consommation devait augmenter, pas plus de 5 verres. Il est
                            recommandé de s'abstenir au moins deux jours par semaine.
                        </li>
                    </ul>
                    Selon l'Office fédéral de la statistique, environ 80% de la population
                    âgée de 15 à 74 ans et vivant en Suisse consomme de l'alcool à faible
                    risque ou n'en consomme pas.
                </>
            ),
            middle: (
                <>
                    <h5>Possiblement à risque</h5>
                    Ce niveau comprend toutes les personnes qui se situent entre les
                    personnes à faible risque et celles qui présentent un risque chronique
                    ou les buveurs et buveuses excessifs.
                </>
            ),
            high: (
                <>
                    <h5>Risque chronique ou ivresse ponctuelle</h5>
                    <ul>
                        <li>
                            <b>Une consommation à risque chronique signifie:</b> ≥ 4 verres
                            standards de boisson alcoolisée par jour pour les hommes, ≥ 2
                            verres pour les femmes.
                        </li>
                        <li>
                            <b>Ivresse ponctuelle:</b> On parle dans la recherche sur l'alcool
                            lorsque les hommes boivent cinq verres standards d'alcool ou plus
                            et les femmes quatre verres ou plus en l'espace de quelques
                            heures, au moins une fois par mois.
                        </li>
                    </ul>
                    Selon l'Office fédéral de la statistique, 5% de la population suisse
                    ont une consommation d'alcool à risque chronique et 16% s'enivrent au
                    moins une fois par mois. Cela signifie qu'environ une personne sur
                    cinq consomme de l'alcool de manière abusive, ce qui représente plus
                    d'un million de Suisses.
                </>
            )
        }
    },
    evaluation: {
        title:
            " Comparaison de la quantité et de la fréquence de votre consommation d'alcool",
        userMarker: 'Vous vous situez ici.',
        frequency: [
            'Quotidiennement',
            'Trois à six fois par semaine',
            'Une à deux fois par semaine',
            "Moins d'une fois par semaine",
            'Jamais'
        ],
        chart1: {
            title:
                "Voici le nombre de verres standards d'alcool que vous buvez par semaine",
            sub: ['par rapport aux ', 'participantes et participants'],
            gender: ['Hommes', 'Femmes'],
            key: [
                "Nombre de verres standards d'alcool par semaine",
                'Nombre de participants',
                'Nombre de participantes'
            ]
        },
        chart2: {
            title: 'Voici la fréquence à laquelle vous buvez',
            sub: [' par rapport aux ', ' participantes et participants'],
            gender: ['Hommes', 'Femmes']
        },
        chart3: {
            title:
                'Voici la fréquence à laquelle vous buvez par rapport à la population suisse',
            sub: ["Données de l'Office fédéral de la statistique"],
            gender: ['Hommes', 'Femmes']
        },
        source: [
            'Sources:',
            <>
                <a href='https://www.bfs.admin.ch/bfs/fr/home/statistiques/sante/determinants/alcool.html'>
                    Office fédéral de la statistique
                </a>
                ,{' '}
                <a href='https://www.addictionsuisse.ch/' target={'_blank'}>
                    addictionsuisse.ch
                </a>
            </>
        ]
    },
    footer: {
        questions: [
            "L'article était-il informatif?",
            'À quel point était-il divertissant?',
            'Dans quelle mesure la mise en œuvre technique a-t-elle bien fonctionné?'
        ],
        credits: [
            ['Conception et mise en œuvre', 'Marc Brupbacher, Sebastian Broschinski']
        ]
    }
}
